/**
 * Normalize HH:mm / HH:mm:ss / Date → minutes since midnight (or null).
 * Used by vee-validate `after_time` for user-group working hours.
 * @param {unknown} raw
 * @returns {number|null}
 */
export function timeToMinutes (raw) {
  if (raw == null || raw === '') return null
  if (raw instanceof Date && !Number.isNaN(raw.getTime())) {
    return (raw.getHours() * 60) + raw.getMinutes()
  }
  const text = String(raw).trim()
  const match = text.match(/^([01]?\d|2[0-3]):([0-5]\d)(?::([0-5]\d))?$/)
  if (match) {
    return (Number(match[1]) * 60) + Number(match[2])
  }
  return null
}
